module.exports = __webpack_public_path__ + "static/img/m9.249b39c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m9.png
// module id = OtD3
// module chunks = 12